import { useCarHireExitLink } from "src/exits/hooks/useCarHireExitLink";
import messages from "src/domain/SearchResultsScreen/SearchResultsCarHirePromo/SearchResultsCarHirePromo.messages";
import { useIntl } from "react-intl";
import KeySolid from "src/design-system/icons/KeySolid.svg?react";
import { PanePromoButton } from "../PanePromoButton/PanePromoButton";

export default function CarRentalPromo() {
  const intl = useIntl();

  const [_, handleClick] = useCarHireExitLink({
    event: {
      category: "TripPlanner",
      action: "Click:CarHirePromo",
    },
    exitPoint: {
      view: "tripPlannerSearchResults",
      trigger: "carCta",
      transitMode: "car",
    },
  });

  const promoText = intl.formatMessage(messages.header);
  const tagline = intl.formatMessage(messages.tagline);

  return (
    <PanePromoButton
      promoText={promoText}
      tagline={tagline}
      onClick={handleClick}
      iconSize="xl"
    >
      <KeySolid className="text-icon-primary" />
    </PanePromoButton>
  );
}
